






import { Component, Prop, Mixins } from "vue-property-decorator";
import Context from "@/mixins/context";
import { IProduct } from "@/models/products";

@Component
export default class UProductLink extends Mixins(Context) {
  @Prop({ required: true })
  public productId!: IProduct["id"];
  @Prop({ default: "adminCatalogueProduct" })
  public to!: string;
  @Prop({ default: () => ({}) })
  public params!: object;
  @Prop({ default: "" })
  public classes!: string;

  // Getters
  public get component() {
    if (
      this.isClient ||
      !this.$userCan("staff_get_product", "list_product_categories")
    )
      return { type: "span" };
    return {
      type: "router-link",
      props: {
        class: this.classes,
        to: {
          name: this.to,
          params: {
            ...this.params,
            productId: this.productId
          }
        }
      }
    };
  }
}
